import React, { Component } from "react";
import {FaInstagram, FaLinkedinIn, FaWhatsapp} from "react-icons/fa";
const logoUrl = <img src="/assets/images/logo/logo-light.png" alt="Digital Agency" />;
// const logoGptw = <img src="/assets/images/logo/selo-gptw.svg" alt="great" />

const SocialShare = [
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/company/plugify-br'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/plugifyoficial'},
    {Social: <FaWhatsapp />, link: 'https://wa.me/11930914805?text=Tenho%20interesse%20em%20em%20saber%20mais'},
]

class Footer extends Component{
    render(){
        return(
            <React.Fragment>
                <footer className="footer-area footer-style-01 bg_color--6">
                    {/* Start Call to Action Area  */} 
                    <div className="im-call-to-action-area ptb--70 im-separator">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-lg-8 col-xl-6 col-md-12 col-sm-12 col-12">
                                    <div className="inner">
                                        <h2 className="text-white mb--0 assinaturaFooter" 
                                        style={{
                                            fontSize: 40, 
                                            fontWeight: 900, 
                                            fontFamily: 'Montserrat', 
                                            textAlign: 'left', 
                                            }}>Vamos construir soluções<br /> em TI #juntos</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* End Call to Action Area  */}

                    {/* Start Footer Area  */}
                    <div className="footer-wrapper ptb--70">
                        <div className="container">
                            <div className="row" style={{justifyContent: "space-between", alignItems:"flex-end"}}>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                                    <div className="ft-text">
                                        <div className="logo" style={{maxWidth: 180}}>{logoUrl} </div>
                                        <p style={{
                                            fontSize:16 , 
                                            color:'white', 
                                            lineHeight:1.5,
                                            fontWeight:100
                                            }}>
                                          
                                            Av. das Nações Unidas, 11857, 8 andar<br />Itaim Bibi, São Paulo - SP, 04795-100</p>
                                            <div className="footer-link">
                                        <p className="test" style={{fontSize:18}}></p>
                                        <ul className="ft-link">
                                            <li style={{ 
                                            color:'white'}}>   
                                                Email: <a href="mailto:contato@plugify.com.br">contato@plugify.com.br</a>
                                                </li>           
                                        </ul>
                                        <ul className="ft-link">
                                            <li style={{ 
                                            color:'white',
                                            fontSize:12,
                                            fontWeight:100 }}>   
                                                Razão Social: <span style={{color:'darkgray'}}>Plugify Tecnologia S/A</span> | CNPJ: <span style={{color:'darkgray'}}>23.599.885/0001-92</span>
                                                </li>           
                                        </ul>

                                        <div className="social-share-inner">
                                            <ul className="social-share social-style--2 d-flex justify-content-start liststyle">
                                                {SocialShare.map((val , i) => (
                                                    <li key={i}><a href={`${val.link}`} target={`${val._blank}`}>{val.Social}</a></li>
                                                ))}
                                            </ul>
                                        </div> 
                                    </div>
                                        <p style={{fontSize:12}}>Copyright © 2022 Plugify. Todos os direitos reservados.</p>
                                        
                                        
                                    </div>
                                </div>
                                
                                {/* Start Single Widget  */}
                                    
                                {/* End Single Widget  */}

                                {/* Start Single Widget  */}
                                {/* <div className="col-lg-2 col-md-6 col-sm-6 col-12 mt_md--40 mt_sm--40" style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>             
                                <div className="col-lg-12">
                                <p style={{fontSize:16, color:'#fff', fontWeight: 100}}>Acelerado por:</p>
                                <div className="logo" style={{width: 300}}>{logoLatitud} </div>
                                </div>
                                </div> */}
                                {/* End Single Widget  */}

                                {/* Start Single Widget  */}
                                {/*<div className="col-lg-2 col-md-6 col-sm-6 col-12 mt_md--40 mt_sm--40" style={{display: "flex", justifyContent: "flex-end", alignItems: "center"}}>
                                <div className="logo" style={{maxWidth: 120}}>{logoGptw} </div>
                                </div> *}
                                {/* End Single Widget  */}
                                 <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                                 <div className="ft-link" style={{fontSize:12, textAlign:"right"}}>
                                    <a style={{color:'darkgray'}} onClick href="/PoliticaPrivacidade">Política de Privacidade</a>
                                </div>
                                    
                                 </div>
                            </div>
                        </div>
                    </div>
                    {/* End Footer Area  */}
                </footer>
            </React.Fragment>
        )
    }
}
export default Footer;